/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateNumericEvaluationParameterDtoEvaluationType } from './CreateNumericEvaluationParameterDtoEvaluationType';
import {
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON,
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoEvaluationTypeToJSON,
} from './CreateNumericEvaluationParameterDtoEvaluationType';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateNumericEvaluationParameterDtoLimitType } from './CreateNumericEvaluationParameterDtoLimitType';
import {
    CreateNumericEvaluationParameterDtoLimitTypeFromJSON,
    CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoLimitTypeToJSON,
} from './CreateNumericEvaluationParameterDtoLimitType';
import type { CreateNumericEvaluationParameterDtoDefinition } from './CreateNumericEvaluationParameterDtoDefinition';
import {
    CreateNumericEvaluationParameterDtoDefinitionFromJSON,
    CreateNumericEvaluationParameterDtoDefinitionFromJSONTyped,
    CreateNumericEvaluationParameterDtoDefinitionToJSON,
} from './CreateNumericEvaluationParameterDtoDefinition';

/**
 * 
 * @export
 * @interface CreateNumericEvaluationParameterDto
 */
export interface CreateNumericEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    upperWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    upperFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    lowerFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    lowerWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    max?: number | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateNumericEvaluationParameterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoDefinition}
     * @memberof CreateNumericEvaluationParameterDto
     */
    definition?: CreateNumericEvaluationParameterDtoDefinition | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoDefinition}
     * @memberof CreateNumericEvaluationParameterDto
     */
    definitionParameterValueSet?: CreateNumericEvaluationParameterDtoDefinition | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoEvaluationType}
     * @memberof CreateNumericEvaluationParameterDto
     */
    evaluationType?: CreateNumericEvaluationParameterDtoEvaluationType | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoLimitType}
     * @memberof CreateNumericEvaluationParameterDto
     */
    limitType?: CreateNumericEvaluationParameterDtoLimitType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    $type?: CreateNumericEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const CreateNumericEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateNumericEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateNumericEvaluationParameterDtoTypeEnum = typeof CreateNumericEvaluationParameterDtoTypeEnum[keyof typeof CreateNumericEvaluationParameterDtoTypeEnum];



/**
 * Check if a given object implements the CreateNumericEvaluationParameterDto interface.
 */
export function instanceOfCreateNumericEvaluationParameterDto(value?: unknown): value is CreateNumericEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateNumericEvaluationParameterDtoTypeEnum)[0];
}

export function CreateNumericEvaluationParameterDtoFromJSON(json: any): CreateNumericEvaluationParameterDto {
    return CreateNumericEvaluationParameterDtoFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'allowRepetition': json['allowRepetition'] == null ? undefined : json['allowRepetition'],
        'instruction': json['instruction'] == null ? undefined : json['instruction'],
        'upperWarningLimit': json['upperWarningLimit'] == null ? undefined : json['upperWarningLimit'],
        'upperFailedLimit': json['upperFailedLimit'] == null ? undefined : json['upperFailedLimit'],
        'lowerFailedLimit': json['lowerFailedLimit'] == null ? undefined : json['lowerFailedLimit'],
        'lowerWarningLimit': json['lowerWarningLimit'] == null ? undefined : json['lowerWarningLimit'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'definition': json['definition'] == null ? undefined : CreateNumericEvaluationParameterDtoDefinitionFromJSON(json['definition']),
        'definitionParameterValueSet': json['definitionParameterValueSet'] == null ? undefined : CreateNumericEvaluationParameterDtoDefinitionFromJSON(json['definitionParameterValueSet']),
        'evaluationType': json['evaluationType'] == null ? undefined : CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON(json['evaluationType']),
        'limitType': json['limitType'] == null ? undefined : CreateNumericEvaluationParameterDtoLimitTypeFromJSON(json['limitType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateNumericEvaluationParameterDtoToJSON(value?: CreateNumericEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'isEnabled': value['isEnabled'],
        'allowRepetition': value['allowRepetition'],
        'instruction': value['instruction'],
        'upperWarningLimit': value['upperWarningLimit'],
        'upperFailedLimit': value['upperFailedLimit'],
        'lowerFailedLimit': value['lowerFailedLimit'],
        'lowerWarningLimit': value['lowerWarningLimit'],
        'min': value['min'],
        'max': value['max'],
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        'definition': CreateNumericEvaluationParameterDtoDefinitionToJSON(value['definition']),
        'definitionParameterValueSet': CreateNumericEvaluationParameterDtoDefinitionToJSON(value['definitionParameterValueSet']),
        'evaluationType': CreateNumericEvaluationParameterDtoEvaluationTypeToJSON(value['evaluationType']),
        'limitType': CreateNumericEvaluationParameterDtoLimitTypeToJSON(value['limitType']),
        'decimalPlaces': value['decimalPlaces'],
        '$type': value['$type'],
    });
}

